var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.1547C6.2376 0.440169 7.7624 0.440169 9 1.1547L11.9282 2.8453C13.1658 3.55983 13.9282 4.88034 13.9282 6.3094V9.6906C13.9282 11.1197 13.1658 12.4402 11.9282 13.1547L9 14.8453C7.7624 15.5598 6.2376 15.5598 5 14.8453L2.0718 13.1547C0.834193 12.4402 0.0717969 11.1197 0.0717969 9.6906V6.3094C0.0717969 4.88034 0.834193 3.55983 2.0718 2.8453L5 1.1547Z",
    fill: "#0F58A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletImg);
export default __webpack_public_path__ + "static/media/Bullet_Img.9ce710deef225d28e217cb489141e53b.svg";
export { ForwardRef as ReactComponent };